var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('titles',{attrs:{"titlename":"专业管理","titlecontent":"这里可以管理专业","mbx":_vm.paths}}),_c('manges',{attrs:{"pagesobj":_vm.pagesobj,"tabtitlelist":_vm.tabtitlelsit,"mangesname":_vm.mangesname,"tablist":_vm.tablist}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }